import { SignupFormData } from '@magoosh/act/organisms/signup/types';
import { Reducer } from 'redux';
import { SignupFormActionTypes } from '@magoosh/organisms/signup_form/actions';

const blankState: SignupFormData = {
  authenticityToken: '',
  isEuUser: false
};

export const signupFormReducer: Reducer<SignupFormData> = (state = blankState, action: any) => {
  switch (action.type) {
    case SignupFormActionTypes.INITIALIZE_SIGNUP_FORM:
      return { ...action.signup };
    default:
      return state;
  }
};
